import { render, staticRenderFns } from "./MinisiteResultsPickClassification.vue?vue&type=template&id=6d075cfa&"
import script from "./MinisiteResultsPickClassification.vue?vue&type=script&lang=js&"
export * from "./MinisiteResultsPickClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports